interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  const go = (page: number) => {
    if (page < 1 || page > total) return;
    onChange(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => go(current - 1)}
        disabled={current === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 px-3 text-sm text-foreground-600 transition-colors enabled:hover:border-accent-500 enabled:hover:text-accent-500 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((page, index) =>
        page === "..." ? (
          <span key={`dot-${index}`} className="px-2 text-foreground-500">
            …
          </span>
        ) : (
          <button
            key={page}
            type="button"
            onClick={() => go(page as number)}
            className={`flex h-9 w-9 items-center justify-center rounded-md border text-sm transition-colors ${
              page === current
                ? "border-accent-500 bg-accent-500 font-600 text-background-50"
                : "border-background-200 text-foreground-600 hover:border-accent-500 hover:text-accent-500"
            }`}
          >
            {page}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => go(current + 1)}
        disabled={current === total}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 px-3 text-sm text-foreground-600 transition-colors enabled:hover:border-accent-500 enabled:hover:text-accent-500 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}